import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import ItemCourse from "@components/item-course/item-course";
import QueryHandler from "@components/query-handler/query-handler";

import { useAppDispatch } from "@hooks/use-store";
import {
  currentCoinsUpload,
  progressUpload,
  setAdsForceRefresh,
} from "@store/app/app.slice";
import { ICourse } from "@typings/global.types";

import { useGetCourseQuery } from "../../api/course";
import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";
import { useUpdateUserInfoMutation } from "../../api/user-info";

type PropsType = {
  course: ICourse;
  closeModal?: () => void;
  className?: string;
};

function WrapperItemsCourse({ course, closeModal, className }: PropsType) {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  const [
    editUser,
    {
      isLoading: userDataMutationIsLoading,
      isError: userDataMutationIsError,
      error: userDataMutationErrorMessage,
      isSuccess,
    },
  ] = useUpdateUserInfoMutation();
  const handleChangeCourse = () => {
    if (data?.user.blockExercise) {
      const userId = data?.user.id;
      window.location.href = `/u${userId}/unlimited-typing/`;
      return;
    }

    if (course.id === data?.user.courseId) {
      if (closeModal) closeModal();
      return;
    }
    // dispatch(errorsUpdate(0));
    // dispatch(speedUpdate(0));
    // dispatch(startTypingUpload(0));
    dispatch(progressUpload(0));
    dispatch(currentCoinsUpload(0));
    // dispatch(correctUpdate(0));

    editUser({
      params: {
        courseId: course.id,
      },
    });

    if (closeModal) closeModal();

    dispatch(setAdsForceRefresh(true));
  };

  const isCourseStartButton =
    course.id === data?.user.courseId ||
    (course.isStartedByUser && !course.isCompletedByUser);

  return (
    <div className='md:flex md:items-end md:justify-between'>
      <QueryHandler
        isError={userDataMutationIsError}
        errorMessage={userDataMutationErrorMessage}
      >
        <ItemCourse
          className={className}
          courseName={course.layoutName}
          valueInProgress={course.currentExerciseNumber ?? 0}
          progress={
            (course.completedExercisesCount / course.exercisesCount) * 100
          }
          completedLessonsCount={course.completedLessonsCount}
          lessonsCount={course.lessonsCount}
          exercisesCount={course.exercisesCount}
          completedExercisesCount={course.completedExercisesCount}
        />
        <button
          className={classNames("btn", {
            "btn-secondary": !isCourseStartButton,
            "btn-primary": isCourseStartButton,
          })}
          type='button'
          onClick={handleChangeCourse}
        >
          {isCourseStartButton ? (
            <FormattedMessage id='continue' />
          ) : (
            <FormattedMessage id='select' />
          )}
        </button>
      </QueryHandler>
    </div>
  );
}

export default WrapperItemsCourse;
